/**
 * Main persistent/state storage for dashboard
 *
 *  - teamFilterAtom: array of team ids
 *  - questionFilterAtom: array of question ids
 *  - dateFilterAtom: object with from and to dates
 *  - locationFilterAtom: array of location ids, this is the Google place id's
 *  - generalFilterAtom: object with source and format arrays
 *
 * To use:
 *  import { teamFilterAtom } from '@/Stores';
 *  ...inside component...
 *  const [teamFilter, setTeamFilter] = useAtom(teamFilterAtom);
 */
import { atomWithLocalStorage } from "@/Utilities/Utilities";
import { SCOPE_OPTIONS }        from "@/Enums/scopes";

const oneDayInSeconds = 1000 * 60 * 60 * 12;

export const budgetMunicipalityFilterAtom = atomWithLocalStorage('budget/municipalityFilterAtom', null, oneDayInSeconds);
export const budgetTeamFilterAtom = atomWithLocalStorage('budget/teamFilterAtom', null, oneDayInSeconds);
export const budgetScopeFilterAtom = atomWithLocalStorage('budget/scopeFilterAtom', SCOPE_OPTIONS.map(scope => scope.value), oneDayInSeconds);
export const budgetGraphModeAtom = atomWithLocalStorage('budget/graphModeAtom', 'current', oneDayInSeconds);
